import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AIModeState {
  isAIMode: boolean;
  userQuery: string;
  aiQuery: string;
  initialAllCount: number;
  initialFullCount: number;
  summary: string;
  summaryLoading: boolean;
  summaryExpanded: boolean;
  // lastInsightQuery: string;

  // New state
  articleIds: string;
}

const initialState: AIModeState = {
  isAIMode: false,
  userQuery: "",
  aiQuery: "",
  initialAllCount: 0,
  initialFullCount: 0,
  summary: "",
  summaryLoading: false,
  summaryExpanded: true,
  // lastInsightQuery: "",

  // Initial value
  articleIds: "",
};

interface EnterAIModePayload {
  userQuery: string;
  aiQuery: string;
  initialAllCount?: number;
  initialFullCount?: number;

  // Optional when entering AI mode
  articleIds?: string;
}

const aiModeSlice = createSlice({
  name: "aiMode",
  initialState,
  reducers: {
    enterAIMode(state, { payload }: PayloadAction<EnterAIModePayload>) {
      state.isAIMode = true;
      state.userQuery = payload.userQuery;
      state.aiQuery = payload.aiQuery;
      state.initialAllCount = payload.initialAllCount ?? 0;
      state.initialFullCount = payload.initialFullCount ?? 0;
      state.summary = "";
      state.summaryLoading = false;
      state.summaryExpanded = true;
      //state.lastInsightQuery = "";

      // Store article IDs
      state.articleIds = payload.articleIds ?? "";
    },
    exitAIMode(state) {
      state.isAIMode = false;
      state.userQuery = "";
      state.aiQuery = "";
      state.initialAllCount = 0;
      state.initialFullCount = 0;
      state.summary = "";
      state.summaryLoading = false;
      state.summaryExpanded = true;
      // state.lastInsightQuery = "";

      // Reset
      state.articleIds = "";
    },
    setAISummary(state, { payload }: PayloadAction<string>) {
      state.summary = payload;
    },
    setAISummaryLoading(state, { payload }: PayloadAction<boolean>) {
      state.summaryLoading = payload;
    },
    setAISummaryExpanded(state, { payload }: PayloadAction<boolean>) {
      state.summaryExpanded = payload;
    },
    // setLastInsightQuery(state, { payload }: PayloadAction<string>) {
    //   state.lastInsightQuery = payload;
    // },

    setArticleIds(state, { payload }: PayloadAction<string>) {
      state.articleIds = payload;
    },
  },
});

export const {
  enterAIMode,
  exitAIMode,
  setAISummary,
  setAISummaryLoading,
  setAISummaryExpanded,
  // setLastInsightQuery,
  setArticleIds,
} = aiModeSlice.actions;

export default aiModeSlice.reducer;
